/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('ProjectDetailHomeController', ProjectDetailHomeController);

    ProjectDetailHomeController.$inject = ['$scope', '$rootScope', '$sce', '$state', 'previousState', 'DataUtils', 'entity', 'ProjectBoard', '$window', '$location', 'AlertService', 'Lightbox'];

    function ProjectDetailHomeController($scope, $rootScope, $sce, $state, previousState, DataUtils, entity, ProjectBoard, $window, $location, AlertService, Lightbox) {
        var vm = this;
        vm.goTo = goTo;

        vm.project = entity;
        vm.validPlaces = vm.project.bookedPlaces.countAngemeldet + vm.project.bookedPlaces.countWarteliste;
        vm.freePlaces = vm.project.places - vm.validPlaces;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.bookUrl =  $location.protocol() + "://" + location.host + "/" + $state.href("project.book", {id: vm.project.id, type: vm.project.type});

        var clipboardBookUrl = new ClipboardJS(document.getElementById("copyUrlButton"));
        clipboardBookUrl.on('success', function(e) {
            $scope.$apply(function() {
                AlertService.success("Anmeldelink wurde in die Zwischenablage kopiert.");
            });
            e.clearSelection();
        });

        clipboardBookUrl.on('error', function(e) {
            $scope.$apply(function() {
                AlertService.error("Anmeldelink konnte nicht kopiert werden.");
            });
        });

        var unsubscribe = $rootScope.$on('askApp:projectUpdate', function(event, result) {
            vm.project = result;
            vm.validPlaces = vm.project.bookedPlaces.countAngemeldet + vm.project.bookedPlaces.countWarteliste;
            vm.freePlaces = vm.project.places - vm.validPlaces;
        });

        $scope.renderHtml = function(code) {
            return $sce.trustAsHtml(code);
        };

        $scope.openLightboxModal = function(index, image) {
            var images = [{'url': image}];
            Lightbox.openModal(images, index);
        };

        $scope.$on('$destroy', unsubscribe);

        function goTo(url) {
            $window.open(url, "_blank");
        }
    }
})();
